import "./index.scss"
import Sidebar from "../Sidebar";
import { useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import LogoTitle from '../../assets/images/logo-s.png'
import CoverPhoto from '../../assets/images/Cover-Photo.png'

const Home = () => {
    const [letterClass] = useState('text-animate')

  const nameArray = ['u', 'l', 'a', 'g', 'n', 'a']
  const jobArray = [
    '.',
    ' ',
    'W',
    'e',
    'l',
    'c',
    'o',
    'm',
    'e',
    ' ',
    'h',
    'e',
    'r',
    'e',
    '!'
  ]
    return (
        <>
        <Sidebar />
        <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <span className={`${letterClass} _12`}> </span>
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            <img
              src={LogoTitle}
              alt="JavaScript Developer Name, Web Developer Name"
            />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            />
          </h1>
          <h2>Resilient/ Includer/ Problem-solver</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
          <img
              className="fade-in-image"
              src={CoverPhoto}
              alt="JavaScript,  Developer"
            />
        </div>
      </div>

      <Loader type="pacman" />
        </>
    );
}
export default Home